module.exports = __webpack_public_path__ + "static/media/phoneIcon.36962ace.svg";